<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	export let isOpen = false;
	export let issue = null;
	export let isSubmitting = false;
	// The backend's message when moving the issue fails.
	export let error = "";

	const dispatch = createEventDispatcher();

	function close() {
		if (isSubmitting) return;
		dispatch("close");
	}

	function confirm() {
		if (isSubmitting) return;
		dispatch("confirm", issue);
	}
</script>

<!-- Can't be dismissed (backdrop, Esc or ✕) while a request is in flight. -->
<Modal
	{isOpen}
	toggle={close}
	backdrop={isSubmitting ? "static" : true}
	keyboard={!isSubmitting}
	centered
>
	<ModalHeader toggle={isSubmitting ? undefined : close}
		>Move issue to backlog</ModalHeader
	>
	<ModalBody>
		<ErrorMessageHandler message={error} />
		<p class="mb-0">This issue will be moved to the vehicle's backlog.</p>
	</ModalBody>
	<ModalFooter>
		<Button
			class="themeButton backButton"
			disabled={isSubmitting}
			on:click={close}>Cancel</Button
		>
		<Button
			class="themeButton primary"
			disabled={isSubmitting}
			on:click={confirm}>Move</Button
		>
	</ModalFooter>
</Modal>
